import React, { useState } from "react";
import { Box, Modal } from "@material-ui/core";

const modalBoxStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '92%',
    maxWidth: '700px',
    bgcolor: '#121212',
    border: '5px solid gold',
    borderRadius: '15px',
    boxShadow: '0 10px 40px rgba(255, 215, 0, 0.4)',
    padding: '25px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    background: 'linear-gradient(145deg, #1a1a1a, #000000)',
    zIndex: 1000000,
    height: '600px',
};

const StartPositionModal = ({ onPositionUpdate, onClose, currentFen, currentMoveIdx }) => {
    const [modalOpen, setModalOpen] = useState(true);



    const handleResetTrailingMoves = () => {

        onPositionUpdate(currentFen, { resetMoves: true });
        setModalOpen(false);
        onClose && onClose();
    };

    const handleKeepTrailingMoves = () => {

        onPositionUpdate(currentFen, { resetMoves: false, currentMoveIdx });
        setModalOpen(false);
        onClose && onClose();
    };

    return (
        <Modal
            open={modalOpen}
            onClose={() => {

                setModalOpen(false);
                onClose && onClose();
            }}
        >
            <Box sx={modalBoxStyle}>
                <div style={{
                    color: 'gold',
                    fontSize: '32px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    borderBottom: '2px solid gold',
                    padding: '20px',
                    letterSpacing: '3px'
                }}>
                    SETTING NEW STARTING POSITION
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <div style={{ color: '#ff0050', fontSize: '24px', textAlign: 'center', maxWidth: '', lineHeight: '1.5', fontWeight: 'bold' }}>a) Start fresh from here. Existing moves are removed.</div>

                    <div style={optionContainerStyle}>
                        <button
                            style={{ ...buttonStyle, backgroundColor: '#ff0050', border: '3px solid #ff0050' }}
                            onClick={handleResetTrailingMoves}
                            onMouseOver={(e) => {
                                e.currentTarget.style.transform = 'translateY(-3px)';
                                e.currentTarget.style.boxShadow = '0 6px 15px rgba(255, 0, 80, 0.4)';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.4)';
                            }}
                        >
                            Reset Trailing Moves
                        </button>

                    </div>

                    <div style={optionContainerStyle}>


                        <div style={{ color: '#57b047', fontSize: '24px', textAlign: 'center', maxWidth: '', lineHeight: '1.5', fontWeight: 'bold' }}>b) Maintain all existing moves that trail this position.</div>
                        <button
                            style={{ ...buttonStyle, backgroundColor: '#57b047', border: '3px solid #57b047' }}
                            onClick={handleKeepTrailingMoves}
                            onMouseOver={(e) => {
                                e.currentTarget.style.transform = 'translateY(-3px)';
                                e.currentTarget.style.boxShadow = '0 6px 15px rgba(87, 176, 71, 0.4)';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.4)';
                            }}
                        >
                            Keep Trailing Moves
                        </button>
                    </div>
                    <div>
                        <button
                            style={cancelButtonStyle}
                            onClick={() => {
                                setModalOpen(false);
                                onClose && onClose();
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.transform = 'translateY(-3px)';
                                e.currentTarget.style.boxShadow = '0 6px 15px rgba(0, 0, 0, 0.3)';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.2)';
                            }}
                        >
                            CANCEL
                        </button>
                    </div>
                </div>


            </Box>
        </Modal>
    );
};

const optionContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '15px',
    padding: '20px',
    borderRadius: '10px',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    transition: 'all 0.3s ease',
};

const buttonStyle = {
    padding: '15px 20px',
    width: '300px',
    fontSize: '22px',
    fontWeight: 'bold',
    borderRadius: '8px',
    cursor: 'pointer',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.4)',
    letterSpacing: '1px',
    color: 'white',
    transition: 'all 0.3s ease',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

const descriptionStyle = {
    fontSize: '16px',
    color: 'white',
    textAlign: 'center',
    maxWidth: '500px',
    lineHeight: '1.5',
};

const cancelButtonStyle = {
    padding: '12px 20px',
    alignSelf: 'center',
    marginTop: '20px',
    backgroundColor: '#ff0000',
    color: 'white',
    border: '3px solid #ff0000',
    borderRadius: '8px',
    cursor: 'pointer',
    letterSpacing: '3px',
    fontSize: '18px',
    fontWeight: 'bold',
    width: '200px',
    transition: 'all 0.3s ease',
};

export default StartPositionModal; 